import img0075678602399 from "./0075678602399.jpg";
import img0075678602399B from "./0075678602399B.jpg";
import img0075678602412 from "./0075678602412.jpg";
import img0075678602412B from "./0075678602412B.jpg";
import img0603497821396 from "./0603497821396.jpg";
import img0603497821396B from "./0603497821396B.jpg";
import img5021732437938 from "./5021732437938.jpg";
import img0075678602382 from "./0075678602382.jpg";
import img0075678602382B from "./0075678602382B.jpg";
import img0075678602375 from "./0075678602375.jpg";
import img0075678602375B from "./0075678602375B.jpg";

const records = [
  {
    artist: "Don Toliver",
    title: "Heaven or Hell (Chopnotslop Remix) (5th Anniversary Edition)",
    format: "LP - Amethyst Vinyl",
    description:
      'Version exclusive “chopped and screwed” avec l\'album remixé par DJ Candlestick. Cette version déjà disponible en digital est proposée pour la première fois en vinyle pour le Record Store Day pour le 5ème anniversaire. Inclus les 4 singles "No Idea", "Can’t Feel My Legs", "Had Enough" et "After Party" et les participations de Travis Scott, Kaash Paige, Sheck Wes, Quavo et Offset.',
    ref: [img0075678602399, img0075678602399B],
  },
  {
    artist: "Gunna",
    title: "Wunna",
    format: "2LP - Emerald Vinyl",
    description:
      'Edition Deluxe de l\'album Wunna de Gunna. Inclus les singles "Skybox", "Wunna" et "Dollaz on my Head". On retrouve sur cet album des featurings de Young Thug, Lil Baby, Roddy Ricch, et Travis Scott.',
    ref: [img0075678602412, img0075678602412B],
  },
  {
    artist: "Ice T",
    title: "Power Rarities",
    format: "LP - Black Ice/White Splatter Vinyl",
    description:
      'Compilation de raretés issues des sessions d\'enregistrement de l\'album Power. Inclus des versions remixes et instrumentales de ses classiques dont "High Rollers" et "I\'m Your Pusher".',
    ref: [img0603497821396, img0603497821396B],
  },
  {
    artist: "Joey Valence & Brae",
    title: "Good Songs by JVB",
    format: "LP",
    description:
      "Cet album comprend 12 des chansons les plus appréciées des fan de JVB tirées de leurs 3 premiers albums, dont 4 titres qui font leurs débuts en vinyle. Cette collection couvre les 3 premières sorties du duo - The Underground Sound EP (2022) et les LP PUNK TACTICS (2023) et NO HANDS (2024), acclamés par la critique et les fans. Cette exclusivité Record Store Day comprend des featuring de Danny Brown, Ayesha Erotica et Z-Trip, ainsi qu'une reprise de « 365 » de Charli xcx, qui figurait sur la version digitale deluxe de NO HANDS.",
    ref: [img5021732437938],
  },
  {
    artist: "Lil Uzi Vert",
    title: "Eternal Atake (Deluxe) / LUV Vs. The World 2",
    format: "3LP - Opaque Blue Jay Vinyl",
    description: "Version Deluxe du 2ème album de Lil Uzi Vert sorti en 2020.",
    ref: [img0075678602382, img0075678602382B],
  },
  {
    artist: "Young Thug",
    title: "Barter 6",
    format: "2LP -Silver Vinyl",
    description:
      "La première mixtape de Young Thug disponible pour la première fois en vinyle. Inclus des featurings de Birdman, T.I., Boosie Badazz et Young Dolph.",
    ref: [img0075678602375, img0075678602375B],
  },
];

export default records;
